import * as React from 'react';
import {
  IconSchool16,
  IconKid16,
  IconHighway16,
  IconHospital16,
  IconHouse16,
  IconMetroMsk16,
  IconRestaurant16,
  IconStore16,
  IconBus16,
  IconParking16,
  IconBike16,
  IconCompetitor16,
  IconWalk16,
  IconCar16,
  IconPolice16,
} from '@cian/ui-kit';
import { IIconProps } from '@cian/ui-kit/icons/internal';

import { IconStreetCar16 } from '../../components/IconStreetCar16';
import { IconScooter16 } from '../../components/IconScooter16';
import { IconNoCar16 } from '../../components/IconNoCar16';
import {
  EInsideTAInfrastructureType,
  EOutsideTAInfrastructureType,
  IRegularInfrastructureType,
  TFutureRoad,
  TMainInfrastructureType,
} from '../../types/map';

export const INFRASTRUCTURE_MAP_ICON_MAP = new Map<string, React.FunctionComponent<IIconProps>>([
  ['cafe', IconRestaurant16],
  ['clinic', IconHospital16],
  ['grocery', IconStore16],
  ['metro', IconMetroMsk16],
  ['nursery', IconKid16],
  ['futureRoad', IconHighway16],
  ['school', IconSchool16],
  ['similar_newbuilding', IconHouse16],

  [EOutsideTAInfrastructureType.busStops, IconBus16],
  [EOutsideTAInfrastructureType.tramStops, IconStreetCar16],
  [EOutsideTAInfrastructureType.metro, IconMetroMsk16],
  [EOutsideTAInfrastructureType.parking, IconParking16],
  [EOutsideTAInfrastructureType.bikeParking, IconBike16],
  [EOutsideTAInfrastructureType.chargingStations, IconCompetitor16],
  [EOutsideTAInfrastructureType.scooterParking, IconScooter16],
  [EOutsideTAInfrastructureType.boulevards, IconWalk16],

  [EInsideTAInfrastructureType.yardWithoutCars, IconNoCar16],
  [EInsideTAInfrastructureType.parking, IconParking16],
  [EInsideTAInfrastructureType.placeOfShortTransportStop, IconCar16],
  [EInsideTAInfrastructureType.bikeParking, IconBike16],
  [EInsideTAInfrastructureType.chargingStations, IconCompetitor16],
  [EInsideTAInfrastructureType.scooterParking, IconScooter16],
  [EInsideTAInfrastructureType.boulevards, IconWalk16],
  [EInsideTAInfrastructureType.trafficSafetyElements, IconPolice16],
]);

export const ALWAYS_VISIBLE_INFRASTRUCTURE_TYPES: string[] = [
  'main' as TMainInfrastructureType,
  'futureRoad' as TFutureRoad,
];

export const RECOMMENDED_NEWBUILDING_INFRASTRUCTURE_TYPE: IRegularInfrastructureType = {
  title: 'Похожие ЖК',
  type: 'similar_newbuilding',
};

export const INFRASTRUCTURE_MAP_SQUARE_ICON = ['similar_newbuilding'];
